module.exports = __webpack_public_path__ + "img/zhebiaomei.da0ee80b.png";